var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditInfoWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEditInfoWarning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-RHP-Edit-Profile--Description",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile-Full-Typing",
    transform: "translate(-13.000000, -315.000000)",
    fill: "#A5A5A5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0563893,327.251194 L22.8562993,315.748472 C22.6753447,315.457761 22.3504425,315.28 21.9999764,315.28 C21.6495104,315.28 21.3246081,315.45773 21.1436535,315.748472 L13.9836273,327.251194 C13.7974134,327.550365 13.791899,327.923518 13.9692517,328.227691 C14.1466044,328.531895 14.4792842,328.72 14.8399184,328.72 L28.2000663,328.72 C28.5607005,328.72 28.8933803,328.531864 29.070733,328.227691 C29.2480857,327.923487 29.2426032,327.550365 29.0563893,327.251194 Z M21.7649388,319.12 C22.1522674,319.12 22.48,319.346014 22.48,319.746616 C22.48,320.969012 22.3409628,322.725638 22.3409628,323.948034 C22.3409628,324.266497 22.0032925,324.4 21.7649388,324.4 C21.4471739,324.4 21.1790072,324.266466 21.1790072,323.948034 C21.1790072,322.725638 21.04,320.969012 21.04,319.746616 C21.04,319.346014 21.3577649,319.12 21.7649388,319.12 Z M21.7647089,326.32 C21.3506139,326.32 21.04,325.983378 21.04,325.6 C21.04,325.207265 21.3505854,324.88 21.7647089,324.88 C22.1505791,324.88 22.48,325.207265 22.48,325.6 C22.48,325.983378 22.1505791,326.32 21.7647089,326.32 Z",
    id: "icEditInfoWarning"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditInfoWarning);
export default __webpack_public_path__ + "static/media/icEditInfoWarning.3d8f9b9770f505adc99612f9857c46c9.svg";
export { ForwardRef as ReactComponent };